import { render, staticRenderFns } from "./message-content-image.vue?vue&type=template&id=6dc8cdb1&scoped=true&"
import script from "./message-content-image.vue?vue&type=script&lang=js&"
export * from "./message-content-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc8cdb1",
  null
  
)

export default component.exports